import LFCBaseCharts from '_components/charts/base/LFCBaseCharts';
import {useTranslation} from 'react-i18next';

import {useTheme} from '@mui/material';

type tsign = '=' | '<' | '<=' | '>=' | '>';
/**
 * パラメータ
 */
interface Props {
  title: string;
  source: any[];
  valueKey: string;
  totalValueKey: string; //総数
  valueUnit?: string; //単位
  targetPar?: number; //目標値(%)
  targetComparisonSign?: tsign; //目標値 <-> 値 の比較記号
  reverse?: boolean; //比率をサブ項目で表示にする
}

/**
 * LFCSingleValuePiePar
 * 単値を比率　＆　目標達成度を加味した円チャート付きで表現します。
 * 目標値が無い場合常に100%緑になります。
 */
const LFCSingleValuePiePar = (props: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  /**
   * 符号の言語化
   * @param targetComparisonSign
   * @returns
   */
  const getDispSign = (targetComparisonSign: tsign | undefined) => {
    switch (targetComparisonSign) {
      case '=':
        return '';
      case '<':
        return '超え';
      case '<=':
        return '以上';
      case '>=':
        return '以下';
      case '>':
        return '未満';
      default:
        return '';
    }
  };

  /**
   * 目標達成判定をします
   * @param value
   * @param targetValue
   * @param targetComparisonSign
   * @returns
   */
  const judgeTarget = (
    value: number,
    targetValue: number | undefined,
    targetComparisonSign: tsign | undefined
  ) => {
    if (targetValue == null) {
      // 目標なしの場合
      return true;
    }

    switch (targetComparisonSign) {
      case '=':
        return targetValue <= value;
      case '<':
        return targetValue < value;
      case '<=':
        return targetValue <= value;
      case '>=':
        return targetValue >= value;
      case '>':
        return targetValue > value;
      default:
        return true;
    }
  };

  return props.source.length > 0 ? (
    <LFCBaseCharts
      option={{
        toolbox: {},
        ...(props.targetPar
          ? {
              title: {
                text: t('目標'),
                textStyle: {
                  fontSize: '0.875rem'
                },
                subtext: ` ${props.targetPar.toLocaleString()}% ${getDispSign(
                  props.targetComparisonSign
                )}`,
                subtextStyle: {
                  fontSize: '1.5rem'
                },
                borderWidth: 3,
                borderColor: theme.palette.divider,
                borderRadius: 5,
                top: 20,
                left: 1
              }
            }
          : null),
        select: {disabled: true},
        series: [
          {
            type: 'pie',
            radius: ['60%', '90%'],
            data: [
              {value: Number(props.source[0][props.valueKey]), name: 'main'},
              {
                value:
                  Number(props.source[0][props.totalValueKey]) -
                  Number(props.source[0][props.valueKey]),
                name: 'sub',
                label: {show: false}
              }
            ],
            itemStyle: {
              color: (params: any) => {
                if (params['name'] === 'main') {
                  if (
                    !judgeTarget(params['percent'], props.targetPar, props.targetComparisonSign)
                  ) {
                    // 目標未達の場合
                    return theme.palette.error.main;
                  }
                  return theme.palette.success.main;
                }
                return theme.palette.action.disabled;
              }
            },
            label: {
              show: true,
              position: 'center',
              formatter: (params: any) => {
                if (params['percent'] !== undefined && params['value'] !== undefined) {
                  const strP = {
                    title: props.title,
                    val: params['percent'].toFixed(1),
                    val_unit: '%',
                    val_sub:
                      params['value'].toLocaleString() + (props.valueUnit ? props.valueUnit : '')
                  };
                  return props.reverse
                    ? ` {title|${strP.title}} \n{hr|}\n{val|${strP.val_sub}}\n {val_sub|${strP.val}${strP.val_unit}} `
                    : ` {title|${strP.title}} \n{hr|}\n{val|${strP.val}}{val_unit|${strP.val_unit}}\n {val_sub|${strP.val_sub}} `;
                }
              },
              // backgroundColor: mySettings.isDark ? "#424242" : "#FFF",
              padding: 5,
              rich: {
                title: {
                  fontSize: '0.875rem',
                  color: theme.palette.text.primary,
                  // align: "center",
                  // lineHeight: 25,
                  padding: [0, 0, 5, 0]
                },
                hr: {
                  borderColor: theme.palette.divider,
                  width: '100%',
                  align: 'left',
                  borderWidth: 1,
                  height: 0
                },
                val: {
                  fontSize: '2rem',
                  color: theme.palette.text.primary,
                  // align: "center",
                  fontWeight: 'bold',
                  verticalAlign: 'bottom',
                  padding: [7, 0, 5, 0]
                  // lineHeight: 50,
                },
                val_unit: {
                  fontSize: '0.75rem',
                  color: theme.palette.text.primary,
                  verticalAlign: 'bottom',
                  padding: [7, 0, 5, 0]
                },
                val_sub: {
                  fontSize: '0.875rem',
                  color: theme.palette.background.default, //theme.palette.grey[50],
                  textBorderWidth: 0,
                  backgroundColor: theme.palette.text.secondary, //theme.palette.grey[900],
                  align: 'center',
                  padding: 5
                }
              }
            }
          }
        ]
      }}
    />
  ) : (
    <></>
  );
};

export default LFCSingleValuePiePar;
